import React from 'react';
import { keepTwoOrLine, keepTwoAndWanOrLine } from '@/utils/utils';
import { V2HighEnergyDeviceAnalysisRuntimeTrendPostResponse } from '@maxtropy/device-customer-apis-v2';
import styles from './index.module.scss';
import { Spin } from 'antd';

export interface DurationCardProps {
  label: string;
  duration?: number;
  energy?: number;
  rate?: number;
  cost?: number;
}

export interface DurationCardsProps {
  data?: V2HighEnergyDeviceAnalysisRuntimeTrendPostResponse;
  runtimeTrendLoading: boolean;
}

const DurationCards: React.FC<DurationCardsProps> = ({ data, runtimeTrendLoading }) => {
  const cardData: DurationCardProps[] = [
    {
      label: '运行时长',
      duration: data?.runningTime,
      energy: data?.runningEnergy,
      rate: data?.runningPercentage,
      cost: data?.runningCost,
    },
    {
      label: '待机时长',
      duration: data?.standbyTime,
      energy: data?.standbyEnergy,
      rate: data?.standbyPercentage,
      cost: data?.standbyCost,
    },
    {
      label: '停机时长',
      duration: data?.shutdownTime,
      energy: data?.shutdownEnergy,
      rate: data?.shutdownPercentage,
      cost: data?.shutdownCost,
    },
  ];

  return (
    <div className={styles.durationCards}>
      {runtimeTrendLoading ? (
        <Spin spinning></Spin>
      ) : (
        <>
          {cardData.map(item => (
            <div className={styles.card} key={item.label}>
              <span className={styles.label}>{item.label}</span>
              <span className={styles.duration}>
                {keepTwoOrLine(item.duration)}h<span className={styles.rate}>({keepTwoOrLine(item.rate)}%)</span>
              </span>
              <div className={styles.energyRow}>
                <div className={styles.energy}>
                  <span className={styles.energyLabel}>用能：</span>
                  <span className={styles.energyValue}>{keepTwoAndWanOrLine(item.energy)}kWh</span>
                </div>
                <div className={styles.energy}>
                  <span className={styles.energyLabel}>用能成本：</span>
                  <span className={styles.energyValue}>{keepTwoAndWanOrLine(item.cost)}元</span>
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default DurationCards;
